import dayjs from 'dayjs';
import 'dayjs/locale/ja';

// 日本時間に設定
dayjs.locale('ja');

export default dayjs;